import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=961e26c2&scoped=true"
import script from "./InputSearch.vue?vue&type=script&lang=js"
export * from "./InputSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961e26c2",
  null
  
)

export default component.exports